export default {
  name: 'addressBookVisitorSignOut',
  miniSave: true,
  uploadFunction: ({ requestFunction, data, saveId }) => {
    return requestFunction
      .methodRequest(`/sites/visitors/addressbook/${data.id}`, 'POST', data)
  },
  restoreSave: (ctx) => {
    const data = ctx.saveObj.data;
    ctx.router.push({ name: `sites-siteid-view-visitors`, params: { siteid: data.siteid } })
  }
}
